export default "__VITE_ASSET__DcpKyRqw__"